import * as Sentry from '@sentry/nextjs';
import { OS_MAP } from 'bowser';

import fetchFromElectron from '~/helpers/deviceChecks/fetchFromElectron';

import checkFullscreen from '../checkFullscreen';
import fetchFromExtension from '../fetchFromExtension';

const checkKioskMode = async (
  osName?: string,
  registrationDetails?: string,
): Promise<boolean | undefined> => {
  if (!osName) {
    return false;
  }

  try {
    if (osName === OS_MAP.ChromeOS) {
      const serialNumber = await fetchFromExtension('SERIAL_NUMBER');
      if (serialNumber.error) {
        throw new Error(serialNumber.error);
      }
      return Boolean(serialNumber.data?.serialNumber) && checkFullscreen();
    }
    const electronKiosk = await fetchFromElectron('KIOSK_MODE');
    if (electronKiosk.data) {
      return electronKiosk.data?.isKiosk;
    }
    throw new Error(electronKiosk.error);
  } catch (err: unknown) {
    const error = new Error(
      JSON.stringify({
        error: String(err),
        registrationDetails,
      }),
    );

    Sentry.captureException(error);
    // eslint-disable-next-line no-console
    console.error('Error while determining Kiosk Mode:', err);
    return undefined;
  }
};

export default checkKioskMode;
